
import React from "react";
import { Toggle } from "@usitsdasdesign/dds-react";
import Text from "atoms/Text";

function InputToggle({
    className = "",
    parentClassName = "max-w-[268px]",
    title = "",
    ...rest
}) {


    return (
        <div className={`flex flex-col w-full ${parentClassName}`}>
            {title && (
                <Text variant="bodySemibold" className="mb-1">
                    {title}
                </Text>
            )}
            <div className={`flex flex-col w-full ${className}`}>
                <Toggle
                    {...rest}
                />
            </div>
        </div>
    );
}

export default InputToggle;
